/** Fase 2 (W14): textos da lixeira de 30 dias do núcleo (botão das telas, gaveta e aba Lixeira de Minha conta). */
export const lixeiraPt = {
  lixeira: {
    botao: 'Lixeira',
    titulo: 'Lixeira',
    aba: 'Lixeira',
    texto: 'O que foi excluído nesta tela nos últimos 30 dias. Desfazer a exclusão volta o registro como estava.',
    textoGeral: 'Registros excluídos nos últimos 30 dias nos módulos que você acessa. Desfazer a exclusão volta o registro como estava.',
    vazioTitulo: 'A lixeira está vazia',
    vazioTexto: 'O que for excluído fica aqui por 30 dias e pode voltar como estava.',
    excluidoEm: 'Excluído em {{data}}',
    por: 'por {{nome}}',
    porAssistente: 'por {{assistente}}, em nome de {{nome}}',
    ate: 'Dá para desfazer até {{data}}',
    desfazer: 'Desfazer exclusão',
    restaurado: 'Exclusão desfeita: o registro voltou',
    semRotulo: 'Registro sem nome',
    filtros: 'Filtros da lixeira',
    filtroModulo: 'Módulo',
    filtroTipo: 'Tipo',
    filtroPor: 'Excluído por',
    filtroQuem: 'Quem excluiu',
    todasPessoas: 'Todas as pessoas',
    limparFiltros: 'Limpar filtros',
    semResultadoFiltro: 'Nada na lixeira com esses filtros',
    grupoTitulo: '{{total}} registros excluídos: {{tipo}}',
    grupoTituloComum: '{{rotulo}}: {{total}} excluídos ({{tipo}})',
    grupoQuando: 'Excluídos em {{data}}',
    grupoQuandoIntervalo: 'Excluídos entre {{de}} e {{ate}}',
    expandir: 'Ver os {{total}} registros do grupo',
    recolher: 'Esconder os registros do grupo',
    registrosDoGrupo: 'Registros do grupo',
    desfazerTudo: 'Desfazer tudo',
    confirmarGrupoTitulo: 'Desfazer a exclusão do grupo',
    confirmarGrupoTexto: 'Os {{total}} registros ({{tipo}}) voltam como estavam. O que não puder voltar (nome repetido, registro pai ainda na lixeira) fica de fora e é avisado.',
    grupoRestaurado: 'Exclusão desfeita: {{n}} registros voltaram',
    grupoParcial: '{{n}} registros voltaram; {{falhas}} não puderam voltar (ainda estão na lixeira)',
    grupoRestam: 'Ainda restam registros neste grupo; desfaça de novo para continuar',
    grupoNadaADesfazer: 'Nada mais a desfazer neste grupo: os registros já saíram da lixeira',
    carregarMaisGrupo: 'Carregar mais registros do grupo',
    lista: 'Registros na lixeira',
  },
};

type Dic = typeof lixeiraPt;

export const lixeiraEn: Dic = {
  lixeira: {
    botao: 'Trash',
    titulo: 'Trash',
    aba: 'Trash',
    texto: 'What was deleted on this screen in the last 30 days. Undoing the deletion brings the record back as it was.',
    textoGeral: 'Records deleted in the last 30 days in the modules you can access. Undoing the deletion brings the record back as it was.',
    vazioTitulo: 'The trash is empty',
    vazioTexto: 'Whatever is deleted stays here for 30 days and can come back as it was.',
    excluidoEm: 'Deleted on {{data}}',
    por: 'by {{nome}}',
    porAssistente: 'by {{assistente}}, on behalf of {{nome}}',
    ate: 'Can be undone until {{data}}',
    desfazer: 'Undo deletion',
    restaurado: 'Deletion undone: the record is back',
    semRotulo: 'Unnamed record',
    filtros: 'Trash filters',
    filtroModulo: 'Module',
    filtroTipo: 'Type',
    filtroPor: 'Deleted by',
    filtroQuem: 'Who deleted',
    todasPessoas: 'Everyone',
    limparFiltros: 'Clear filters',
    semResultadoFiltro: 'Nothing in the trash with these filters',
    grupoTitulo: '{{total}} records deleted: {{tipo}}',
    grupoTituloComum: '{{rotulo}}: {{total}} deleted ({{tipo}})',
    grupoQuando: 'Deleted on {{data}}',
    grupoQuandoIntervalo: 'Deleted between {{de}} and {{ate}}',
    expandir: 'Show the {{total}} records in the group',
    recolher: 'Hide the records in the group',
    registrosDoGrupo: 'Records in the group',
    desfazerTudo: 'Undo all',
    confirmarGrupoTitulo: 'Undo the deletion of the group',
    confirmarGrupoTexto: 'The {{total}} records ({{tipo}}) come back as they were. Any that cannot come back (repeated name, parent record still in the trash) stay out and are reported.',
    grupoRestaurado: 'Deletion undone: {{n}} records are back',
    grupoParcial: '{{n}} records are back; {{falhas}} could not come back (still in the trash)',
    grupoRestam: 'There are still records in this group; undo again to continue',
    grupoNadaADesfazer: 'Nothing left to undo in this group: the records are no longer in the trash',
    carregarMaisGrupo: 'Load more records from the group',
    lista: 'Records in the trash',
  },
};

export const lixeiraEs: Dic = {
  lixeira: {
    botao: 'Papelera',
    titulo: 'Papelera',
    aba: 'Papelera',
    texto: 'Lo que se eliminó en esta pantalla en los últimos 30 días. Deshacer la eliminación devuelve el registro tal como estaba.',
    textoGeral: 'Registros eliminados en los últimos 30 días en los módulos a los que tienes acceso. Deshacer la eliminación devuelve el registro tal como estaba.',
    vazioTitulo: 'La papelera está vacía',
    vazioTexto: 'Lo que se elimine se queda aquí 30 días y puede volver tal como estaba.',
    excluidoEm: 'Eliminado el {{data}}',
    por: 'por {{nome}}',
    porAssistente: 'por {{assistente}}, en nombre de {{nome}}',
    ate: 'Se puede deshacer hasta el {{data}}',
    desfazer: 'Deshacer eliminación',
    restaurado: 'Eliminación deshecha: el registro volvió',
    semRotulo: 'Registro sin nombre',
    filtros: 'Filtros de la papelera',
    filtroModulo: 'Módulo',
    filtroTipo: 'Tipo',
    filtroPor: 'Eliminado por',
    filtroQuem: 'Quién eliminó',
    todasPessoas: 'Todas las personas',
    limparFiltros: 'Limpiar filtros',
    semResultadoFiltro: 'Nada en la papelera con estos filtros',
    grupoTitulo: '{{total}} registros eliminados: {{tipo}}',
    grupoTituloComum: '{{rotulo}}: {{total}} eliminados ({{tipo}})',
    grupoQuando: 'Eliminados el {{data}}',
    grupoQuandoIntervalo: 'Eliminados entre el {{de}} y el {{ate}}',
    expandir: 'Ver los {{total}} registros del grupo',
    recolher: 'Ocultar los registros del grupo',
    registrosDoGrupo: 'Registros del grupo',
    desfazerTudo: 'Deshacer todo',
    confirmarGrupoTitulo: 'Deshacer la eliminación del grupo',
    confirmarGrupoTexto: 'Los {{total}} registros ({{tipo}}) vuelven tal como estaban. Los que no puedan volver (nombre repetido, registro padre aún en la papelera) quedan fuera y se avisa.',
    grupoRestaurado: 'Eliminación deshecha: {{n}} registros volvieron',
    grupoParcial: '{{n}} registros volvieron; {{falhas}} no pudieron volver (siguen en la papelera)',
    grupoRestam: 'Aún quedan registros en este grupo; deshaz de nuevo para continuar',
    grupoNadaADesfazer: 'No queda nada por deshacer en este grupo: los registros ya salieron de la papelera',
    carregarMaisGrupo: 'Cargar más registros del grupo',
    lista: 'Registros en la papelera',
  },
};
